import Crum from '@/components/Crum';
import GoToIpForThePage from '@/components/GoToIpForThePage';
import PageLayout from '@/components/PageLayout';
import Empty from '@/components/Search/Empty';
import SEOlinksA from '@/components/SEOlinksA';
import SupportContactUsPc from '@/components/SupportCommon/SupportContactUs';
import SupportLeftMenu from '@/components/SupportCommon/SupportLeftMenu';
import SupportTitlePC from '@/components/SupportCommon/SupportTitle';
import CustomSpin from '@/components/UI/CustomSpin';
import Image from '@/components/UI/Image';
import Pagination from '@/components/UI/Pagination';
import EFAppQRCode from '@/components/UI/svg/Icons/EFAppQRCode';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFDownLoad from '@/components/UI/svg/Icons/EFDownLoad';
import EFDownloadAppPCSvg from '@/components/UI/svg/Icons/EFDownloadAppPCSvg';
import SupportContactUsH5 from '@/componentsH5/SupportCommon/SupportContactUs';
import SupportTitleH5 from '@/componentsH5/SupportCommon/SupportTitle';
import { URL } from '@/constants';
import seoconfig from '@/seoconfig/support/download';
import { getDownloadCatagoryTree, getDownloadInfo, getIosAppVersion } from '@/service';
import { efFetch, getHostApi, isReadyLang, redirectTo404 } from '@/utils';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { langText } from '@elem/compCommon/Support/langText';
import SupportDownloadA from '@elem/compPage/SupportDownloadA';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import { Collapse, Popover } from 'antd';
import get from 'lodash/get';
import moment from 'moment';
import { GetServerSidePropsContext } from 'next';
import { useEffect, useState } from 'react';
import * as deviceDetect from 'react-device-detect';
import { Navigation, Pagination as swiperPagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoFlowProApp from './EcoFlowProApp';
import EcoFlowProAppH5 from './EcoFlowProAppH5';
import css from './index.module.scss';
import gtm from '@/utils/gtm';
const { EFPic: EFPicPc } = createEFPic('/media/support-download-index/pc/');
const { EFPic: EFPicH5 } = createEFPic('/media/support-download-index/h5/');
const { EFPic } = createEFPic('/media/support-download-index/');

let API_HOST = process.env.NEXT_PUBLIC_API_HOST;
const { APP_ANDROID, APP_IOS, APK_OVERSEAS, APK_CN, APP_IOS_CN, APP_IOS_RU } = URL;
let paramsTemp = {}; //分页查询使用

export default function SupportProduct({ product, categoryTree, iosAppVersionInfo, androidAppVersionInfo, lang, SEO, usSeoMap, isShowUPS }: any) {
    const { Link, isMobile, useLang, useRouter } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('supportdownloadproduct');
    const [isFirstIn, setIsFitstIn] = useState(true); // 是否首次进入页面（未发送请求）
    const [fileList, setFileList] = useState([]);
    const [pageInfo, setPageInfo] = useState({
        page: 1,
        size: 9,
        total: 0,
    });
    const { locale = 'en', query } = useRouter();
    const { hideContactUs = '' } = query;
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const SupportContactUs = isMobile ? SupportContactUsH5 : SupportContactUsPc;
    const [loading, setLoading] = useState(false);
    const [isIOS, setIsIOS] = useState<boolean>(false);
    const SupportTitle = isMobile ? SupportTitleH5 : SupportTitlePC;
    interface productInfo {
        productId: string;
        originType: 'PRODUCT_CATEGORY' | 'PRODUCT' | 'ONLINE'; // 不做特殊处理的type
        type: 'PRODUCT_CATEGORY' | 'PRODUCT' | 'ONLINE'; // 新增ONLINE 线上说明书类型
    }
    const HAS_PRO_APP_SITE = ['eu', 'uk', 'de', 'nl'].includes(locale);

    const [searchValue, setSearchValue] = useState('');
    const i = langText[locale] || langText.en;
    const [type, setType] = useState<'manual' | 'video' | 'approve'>('manual'); // 1.手册 2.视频媒体  3.认证声明
    const [subType, setSubType] = useState<'1' | '2' | '3' | ''>(''); // 1.使用手册 2.维护/排障文档 3.其他相关文档

    const typeTabList: EfTabItemProps[] = [
        {
            type: 'manual',
            title: i.manual,
        },
        {
            type: 'video',
            title: i.media,
        },
        {
            type: 'approve',
            title: i.compliance,
        },
        // {
        //     type: 'app',
        //     title: i.software,
        // },
    ];

    const subTypeTabList: EfTabItemProps[] = [
        {
            type: '',
            title: i.all,
        },
        {
            type: '1',
            title: i.operation,
        },
        {
            type: '2',
            title: i.troubleshooting,
        },
        {
            type: '3',
            title: i.related,
        },
    ];

    function flatten(tree: any[]) {
        let res: any = [];
        for (const item of tree) {
            const { subs } = item;
            if (subs && subs.length) {
                res = res.concat(flatten(subs));
            }
            res.push({ ...item });
        }
        return res;
    }

    const getAppDataLayer = (type: string) => {
        return {
            event: 'uaEvent',
            event_name: 'ecoflow_app',
            button_name: type,
        };
    };

    const getFileDataLayer = (file: any, index: number) => {
        if (file.classify === 'MANUAL') {
            return {
                event: 'uaEvent',
                event_name: 'file_download',
                file_name: file.title,
                position: `Manuals_${index + 1}`,
                button_name: 'pdf',
            };
        } else {
            return {
                event: 'uaEvent',
                event_name: 'video',
                title_name: file.title,
                position: `Manuals_${index + 1}`,
            };
        }
    };
    const iconMap = {
        pdf: {
            fileIcon: <EFPicPc className="fileIcon" name={[`file-icon.webp`, `file-icon.png`]} alt={t('support.download.file_icon')} />,
        },
        video: {
            fileIcon: <EFPicPc className="fileIcon" name={[`file-icon.webp`, `file-icon.png`]} alt={t('support.download.file_icon')} />,
        },
    };
    const breadcrumbData = [{ name: t('crums.crum_home'), link: '/' }, { name: t('crums.crum_support'), link: '/support' }, { name: t('crums.crum_download') }];

    /**
     * 获取所有目录树品类id
     */
    const getAllCategoryIds = (categoryTree: any, idArr: string[] = []) => {
        categoryTree?.forEach((item: any) => {
            if (item.downloadCatagoryType === 'PRODUCT_CATAGORY') {
                idArr.push(item.downloadCatagoryId);
                if (item.subs) {
                    getAllCategoryIds(item.subs, idArr);
                }
            }
        });
        return idArr;
    };

    /**
     * 获取所有父级id列表
     */
    const getAllParentIds = (data: any[], id: string) => {
        if (!id) return [];
        function dfs(data: any[], id: string, parents?: any[]) {
            parents = parents || [];
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                if (item.downloadCatagoryId === id) return parents;
                if (!item?.subs || !item?.subs.length) continue;
                // 往下查找时将当前id入栈
                parents.push(item.downloadCatagoryId);
                if (dfs(item.subs, id, parents).length) return parents;
                // 深度遍历查找未找到时当前id 出栈
                parents.pop();
            }
            // 未找到时返回空数组
            return [];
        }

        return dfs(data, id);
    };

    const getProductInfo = (): productInfo | undefined => {
        const currSeo = usSeoMap.find((seo: any) => seo.url === product);
        if (!currSeo || !currSeo?.sourceId) return;
        const flatCategory = flatten(categoryTree);
        const currCategoryBySeo = flatCategory.find((category: any) => category.downloadCatagoryId === currSeo.sourceId);
        // 判断通过seo信息拿到的产品id是否在目录树中，否 -> return
        if (!currCategoryBySeo) return;

        const productInfo: productInfo = {
            productId: currSeo.sourceId,
            originType: currSeo.type,
            type: currSeo.type,
        };
        // 如果没有子产品 将该品类当作产品
        const currCategory = categoryTree.find((category: any) => category.downloadCatagoryId === productInfo.productId);
        if (!!currCategory && !currCategory.subs?.length) {
            productInfo.type = 'PRODUCT';
        }
        return productInfo;
    };

    const getCurrentCategoryById = (categortyTree: any[], id: string) => {
        const flatCategory = flatten(categortyTree);
        return flatCategory.find((category: any) => category.downloadCatagoryId === id);
    };

    const getDefaultOpenInfo = (productInfo?: productInfo) => {
        if (!productInfo) return {};
        // pc
        const { type, productId } = productInfo;
        const selectIdForPC = type === 'PRODUCT_CATEGORY' ? [] : [productId];
        const parentIds = getAllParentIds(categoryTree, productId);
        const openIdsForPC = type === 'PRODUCT_CATEGORY' ? parentIds.concat(productId) : parentIds;
        const currCategory = getCurrentCategoryById(categoryTree, productId) || {};
        const getListIds = type === 'PRODUCT_CATEGORY' ? getAllCategoryIds([currCategory]).join() : productId;
        // mobile
        let activeTree: any;
        let mainSelectorValue: any;
        let level3Catagories: any;
        let subSelectorValue: any;
        if (!parentIds.length) {
            activeTree = categoryTree.find((category: any) => category.downloadCatagoryId === productId);
            mainSelectorValue = activeTree?.name;
            level3Catagories = [];
            subSelectorValue = null;
        } else {
            const activeTreeId = parentIds[0];
            activeTree = categoryTree.find((category: any) => category.downloadCatagoryId === activeTreeId);
            mainSelectorValue = activeTree?.name;
            const subActiveTreeId = parentIds[1];
            const subActibeTree = activeTree?.subs?.find((item: any) => item.downloadCatagoryId === subActiveTreeId);
            level3Catagories = subActibeTree?.subs || [];
            const subSelector = level3Catagories?.find((item: any) => item.downloadCatagoryId === productId);
            subSelectorValue = subSelector?.name || '';
        }

        return {
            selectIdForPC,
            openIdsForPC,
            getListIds,
            activeTree,
            mainSelectorValue,
            level3Catagories,
            subSelectorValue,
        };
    };

    const productInfo = getProductInfo();
    const defaultOpenInfo = getDefaultOpenInfo(productInfo);

    // 分页查询
    const handlePageChange = (page: number) => {
        console.log('page', page);
        getDownloadList({
            ...paramsTemp,
            page,
        }).finally(() => {
            setPageInfo({ ...pageInfo, page });
            gtm.push({
                __btn_id1: css.downloadContainer,
                __btn_id2: page.toString(),
            });
        });
    };

    // mobile: BEGIN 切换左侧tab
    // 记录右侧selector的选项值
    const [level3Catagories, setLevel3Catagories] = useState(get(categoryTree, '0.subs.0.subs') || []);
    // 记录当前左侧selector选择项
    const [activeTree, setActiveTree] = useState(categoryTree[0]);
    // 设置左侧Selector弹窗中点击一级目录时默认的第一个二级目录的id
    const [defaultActiveId, setDefaultActiveId] = useState('');
    // 左侧选择项点击变动事件： 带 ++ 为二级/三级目录， 否则为一级目录
    const changeCatagory = (catagoryId: any) => {
        if (!catagoryId) {
            return;
        }
        let currentTree = null;
        const idArr = catagoryId?.split('++');
        const leng = idArr?.length;

        setDefaultActiveId(catagoryId);
        if (leng === 1) {
            currentTree = categoryTree?.find((item: any) => item.downloadCatagoryId === catagoryId);
            if (currentTree) {
                setMainSelectorValue(currentTree.name);
                setActiveTree(currentTree);
                if (!currentTree?.subs?.length) {
                    getDownloadList({ productCatagoryIds: currentTree.downloadCatagoryId });
                    setPopShow(false);
                }
            }
        } else if (leng === 2) {
            const [parentId, selfId] = idArr;
            const parentTree = categoryTree?.find((item: any) => item.downloadCatagoryId === parentId);
            if (parentTree) {
                currentTree = parentTree?.subs?.find((item: any) => item.downloadCatagoryId === selfId);
                setActiveTree(currentTree);
            }
        } else if (leng === 3) {
            const [grandParentId, parentId, selfId] = idArr;
            const grandParentTree = categoryTree?.find((item: any) => item.downloadCatagoryId === grandParentId);
            if (grandParentTree) {
                const parentTree = grandParentTree?.subs?.find((item: any) => item.downloadCatagoryId === parentId);
                if (parentTree) {
                    currentTree = parentTree?.subs?.find((item: any) => item.downloadCatagoryId === selfId);
                    setActiveTree(currentTree);
                }
            }
        }
    };
    // 左侧selector弹框的开闭
    const [popShow, setPopShow] = useState(false);
    const handleVisibleChange = (visible: boolean) => {
        setPopShow(visible);
    };
    // 右侧selector下拉框的开闭
    const [selectOpen, setSelectOpen] = useState(false);
    const changeVisibleDropdown = (visible: boolean) => {
        setSelectOpen(visible);
    };

    const handdleChangeSearch = (e) => {
        setSearchValue(e.target.value.trim());
    };

    // 点击左侧Selector弹框中的OK按钮
    const onOk = () => {
        const { downloadCatagoryType, downloadCatagoryId } = activeTree;
        if (downloadCatagoryType === 'PRODUCT_CATAGORY') {
            let ids = '';
            if (activeTree?.subs?.length > 0) {
                activeTree.subs.forEach((item: any) => {
                    if (item.downloadCatagoryType === 'PRODUCT_CATAGORY') {
                        ids += `${item.downloadCatagoryId},`;
                    }
                });
            }
            getDownloadList({
                productCatagoryIds: ids + downloadCatagoryId,
            });
        }
        if (downloadCatagoryType === 'SPU') {
            getDownloadList({
                spuIds: downloadCatagoryId,
            });
        }
        setPopShow(false);
    };
    // 右侧Selector点击选择事件
    const tabChange = (value: any) => {
        setSelectOpen(false);
        getDownloadList({ spuIds: value });
        setSubSelectorValue(level3Catagories.filter((item: any) => item.downloadCatagoryId === value)[0]?.name);
    };
    // 右侧Selector展示的值
    const [subSelectorValue, setSubSelectorValue] = useState(level3Catagories[0]?.name);
    // 三级目录变动时，重新设定右侧Selector展示的值
    useEffect(() => {
        setSubSelectorValue(level3Catagories[0]?.name);
    }, [level3Catagories]);
    // 左侧Selector展示的值
    const [mainSelectorValue, setMainSelectorValue] = useState(categoryTree[0]?.name);
    // 根据一个spuId展开和选中左侧目录 --Mobile
    const openAndSelectDefaultMenu = () => {
        const { activeTree, mainSelectorValue, level3Catagories, subSelectorValue, getListIds } = defaultOpenInfo;
        setActiveTree(activeTree);
        setMainSelectorValue(mainSelectorValue);
        setLevel3Catagories(level3Catagories);
        setTimeout(() => setSubSelectorValue(subSelectorValue), 0);
        const originType = productInfo?.originType;
        const params =
            originType === 'PRODUCT_CATEGORY'
                ? {
                      productCatagoryIds: getListIds,
                  }
                : { spuIds: getListIds };
        getDownloadList(params).catch(() => setIsFitstIn(false));
    };
    // moile: END

    // 获取下载列表
    const getDownloadList = async (params: any) => {
        setLoading(true);
        const { page } = params;
        if (!params?.type && params?.classify !== 'VIDEO_COURSE') {
            params.type = 1;
            params.classify = undefined;
        }
        paramsTemp = params; // 缓存搜索条件
        const res = await getDownloadInfo({ ...params, size: pageInfo.size });
        setLoading(false);
        setIsFitstIn(false);
        if (res.code === '0') {
            res.data?.content?.forEach((item: any) => {
                item.updateTime = moment(item.updateTime).format('YYYY-MM-DD');
            });
            setFileList(res.data?.content || []);
            setPageInfo({ ...pageInfo, total: res.data?.total || 0, page: page || 1 });
        }
    };

    useEffect(() => {
        setIsIOS(deviceDetect.isIOS);
        // 手机端默认展示最后一个层级的第一个目录
        if (isMobile && (product === 'index' || !productInfo?.productId)) {
            if (categoryTree[0] && !categoryTree[0]?.subs?.length) {
                getDownloadList({
                    productCatagoryIds: categoryTree[0]?.downloadCatagoryId,
                }).catch(() => setIsFitstIn(false));
            }
            if (categoryTree[0] && categoryTree[0]?.subs?.length && !categoryTree[0]?.subs[0]?.subs?.length) {
                if (categoryTree[0]?.subs[0]?.downloadCatagoryType === 'PRODUCT_CATAGORY') {
                    getDownloadList({
                        productCatagoryIds: categoryTree[0]?.subs[0]?.downloadCatagoryId,
                    }).catch(() => setIsFitstIn(false));
                }
                if (categoryTree[0]?.subs[0]?.downloadCatagoryType === 'SPU') {
                    getDownloadList({
                        spuIds: categoryTree[0]?.subs[0]?.downloadCatagoryId,
                    }).catch(() => setIsFitstIn(false));
                }
            }
            if (categoryTree[0] && categoryTree[0]?.subs?.length && categoryTree[0]?.subs[0]?.subs?.length) {
                getDownloadList({
                    spuIds: categoryTree[0]?.subs[0]?.subs[0].downloadCatagoryId,
                }).catch(() => setIsFitstIn(false));
            }
        } else if (isMobile && product) {
            openAndSelectDefaultMenu();
        } else {
            const params: any = {};
            if (productInfo?.originType === 'PRODUCT' && defaultOpenInfo.getListIds) {
                params.spuIds = defaultOpenInfo.getListIds;
            } else {
                params.productCatagoryIds = defaultOpenInfo.getListIds || getAllCategoryIds(categoryTree).join();
            }
            getDownloadList(params).catch(() => setIsFitstIn(false));
        }
    }, [isMobile, categoryTree]);

    const showAppRegion = ['au', 'ca', 'us', 'eu', 'uk', 'jp', 'cn', 'de', 'fr', 'za', 'nl'].includes(locale);
    const isEn = ['au', 'ca', 'us', 'eu', 'uk', 'za', 'nl'].includes(locale);
    const [imgPcSrc, setImgPcSrc] = useState(['05-bg', 'png']);
    const [imgH5Src, setImgH5Src] = useState(['05-old-bg', 'png']);
    useEffect(() => {
        if (showAppRegion) {
            if (isEn) {
                setImgPcSrc(['za', 'us'].includes(locale) ? ['05-bg-diff', 'jpg'] : ['05-bg', 'png']);
                setImgH5Src(['za', 'us'].includes(locale) ? ['05-old-bg-diff', 'png'] : ['05-old-bg', 'png']);
            } else {
                setImgPcSrc([`05-bg-${locale}`, 'png']);
                setImgH5Src([`05-old-bg-${locale}`, `png`]);
            }
        } else {
            setImgPcSrc([`download-bg_${appImgLocal}`, 'jpg']);
            setImgH5Src([`download_main_${appImgLocal}`, `jpg`]);
        }
    }, []);

    const handleChangeType = async (val: EfTabItemProps) => {
        switch (val.type) {
            case 'manual':
                setType('manual');
                setSubType('');
                return;
            case 'video':
                setType('video');
                setSubType('');
                return;
            case 'approve':
                setType('approve');
                setSubType('');
                return;
            default:
                return;
        }
    };

    useEffect(() => {
        (async () => {
            const params = { ...paramsTemp };
            if (type === 'manual') {
                params.type = 1;
                params.classify = undefined;
                if (subType) {
                    params.subType = Number(subType);
                } else {
                    params.subType = undefined;
                }
            } else if (type === 'video') {
                params.classify = 'VIDEO_COURSE';
                params.type = undefined;
                params.subType = undefined;
            } else if (type === 'approve') {
                params.type = 2;
                params.classify = undefined;
                params.subType = undefined;
            }
            await getDownloadList(params);
        })();
    }, [type, subType]);

    useEffect(() => {
        console.log('type===', type);
    }, [type]);

    return (
        <PageLayout isNoFixed={true} className={css.downloadFooter} style={{ backgroundColor: '#f8f8f8' }}>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <Crum data={breadcrumbData} />
            <div className="container">
                <div className={`${css.downloadContainer} ${isMobile ? 'downloadContainerH5' : 'downloadContainerPc'}`}>
                    {isMobile ? (
                        <Swiper
                            id="app"
                            className="app-swiper-box"
                            effect="fade"
                            modules={[swiperPagination, Navigation]}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            spaceBetween={0}
                            slidesPerView={'auto'}
                            initialSlide={0}
                            loop={HAS_PRO_APP_SITE}
                        >
                            <SwiperSlide className="swiper-item">
                                <div className="downloadMainBox">
                                    <div className="briefBox">
                                        <div className="sub-title">{lang.site_support_download_app_subtitle}</div>
                                        <div className="logoTitle font-family-bold">
                                            <div className="logoIcon thisImg">
                                                <EFPic name={[`05-logo.webp`, `05-logo.png`]} alt={t('support.download.logo')} className="logo" />
                                            </div>
                                            <h1>{lang.site_support_download_app}</h1>
                                        </div>
                                        <p className="briefDesc font-family-regular">{lang.site_support_download_introduce}</p>
                                        <div className="download-learnmore">
                                            {showAppRegion ? (
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href="/app"
                                                    ariaLabel={t('support.download.app_store')}
                                                    dataLayer={{
                                                        ...getAppDataLayer('App Store'),
                                                        __btn_id1: css.downloadContainer,
                                                        __btn_id2: '/app',
                                                    }}
                                                >
                                                    {t('support.site_support_learn_more')} &gt;
                                                </Link>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        <div className="appStore">
                                            {isIOS ? (
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href={locale === 'cn' ? APP_IOS_CN : locale === 'cis' ? APP_IOS_RU : APP_IOS}
                                                    aria-label={t('support.download.app_store')}
                                                    dataLayer={{
                                                        ...getAppDataLayer('App Store'),
                                                        __btn_id1: css.downloadContainer,
                                                        __btn_id2: locale === 'cn' ? APP_IOS_CN : locale === 'cis' ? APP_IOS_RU : APP_IOS,
                                                    }}
                                                >
                                                    <div className="appStoreImg thisImg">
                                                        <EFPic
                                                            name={[`apple-store.webp`, `apple-store.png`]}
                                                            alt={t('support.download.app_store')}
                                                            className="logo"
                                                        />
                                                    </div>
                                                </Link>
                                            ) : (
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href={APP_ANDROID}
                                                    ariaLabel={t('support.download.google_play')}
                                                    dataLayer={{
                                                        ...getAppDataLayer('Google Play'),
                                                        __btn_id1: css.downloadContainer,
                                                        __btn_id2: APP_ANDROID,
                                                    }}
                                                >
                                                    <div className="appStoreImg thisImg google">
                                                        <EFPic
                                                            name={[`google-play.webp`, `google-play.png`]}
                                                            alt={t('support.download.google_play')}
                                                            className="logo"
                                                        />
                                                    </div>
                                                </Link>
                                            )}
                                            <p className="require font-family-medium">
                                                {isIOS
                                                    ? t('support.download.requires_ios') + iosAppVersionInfo.minOSVersion + t('support.download.above')
                                                    : t('support.download.requires_android') + androidAppVersionInfo.minOSVersion + t('support.download.above')}
                                            </p>
                                        </div>
                                        {!isIOS && (
                                            <div className="download-apk">
                                                (
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href={locale === 'cn' ? APK_CN : APK_OVERSEAS}
                                                    ariaLabel={s('site_support_download_apk')}
                                                    selfWin
                                                    dataLayer={{
                                                        ...getAppDataLayer('Download the EcoFlow App apk file'),
                                                        __btn_id1: css.downloadContainer,
                                                        __btn_id2: locale === 'cn' ? APK_CN : APK_OVERSEAS,
                                                    }}
                                                >
                                                    <span className="imgs">
                                                        <EFDownLoad stroke="none" />
                                                    </span>
                                                    {lang.site_support_download_apk}
                                                </Link>
                                                )
                                            </div>
                                        )}
                                    </div>
                                    <div className="mainImgBox thisImg">
                                        <EFPicH5 name={[`${imgH5Src[0]}.webp`, `${imgH5Src[0]}.${imgH5Src[1]}`]} alt={t('support.download.download_img')} />
                                    </div>
                                </div>
                            </SwiperSlide>
                            {HAS_PRO_APP_SITE && (
                                <SwiperSlide className="swiper-item">
                                    <EcoFlowProAppH5 lang={lang} />
                                </SwiperSlide>
                            )}
                        </Swiper>
                    ) : (
                        <Swiper
                            id="app"
                            className="app-swiper-box"
                            effect="fade"
                            modules={[swiperPagination, Navigation]}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={true}
                            spaceBetween={0}
                            slidesPerView={'auto'}
                            initialSlide={0}
                            loop={HAS_PRO_APP_SITE}
                        >
                            <SwiperSlide className="swiper-item">
                                <div className="downloadMainImg">
                                    <EFPicPc name={[`${imgPcSrc[0]}.webp`, `${imgPcSrc[0]}.${imgPcSrc[1]}`]} alt={t('support.download.download_img')} />
                                    <div className="bg-content">
                                        <div className="sub-title">{lang.site_support_download_app_subtitle}</div>
                                        <div className="logo-content">
                                            <EFPic name={[`05-logo.webp`, `05-logo.png`]} alt={t('support.download.logo')} className="logo logoPic" />
                                            <h1 className="title font-family-semibold">{lang.site_support_download_app}</h1>
                                        </div>
                                        <p className="desc font-family-regular">{lang.site_support_download_introduce}</p>
                                        <div className="download-learnmore">
                                            {showAppRegion ? (
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href="/app"
                                                    ariaLabel={t('support.download.app_store')}
                                                    dataLayer={{
                                                        ...getAppDataLayer('App Store'),
                                                        __btn_id1: css.downloadContainer,
                                                        __btn_id2: '/app',
                                                    }}
                                                >
                                                    {t('support.site_support_learn_more')} &gt;
                                                </Link>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        <div className="download-play">
                                            <div className="play-item">
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href={locale === 'cn' ? APP_IOS_CN : locale === 'cis' ? APP_IOS_RU : APP_IOS}
                                                    ariaLabel={t('support.download.app_store')}
                                                    dataLayer={{
                                                        ...getAppDataLayer('App Store'),
                                                        __btn_id1: css.downloadContainer,
                                                        __btn_id2: locale === 'cn' ? APP_IOS_CN : locale === 'cis' ? APP_IOS_RU : APP_IOS,
                                                    }}
                                                >
                                                    <EFPic
                                                        name={[`apple-store.webp`, `apple-store.png`]}
                                                        alt={t('support.download.app_store')}
                                                        className="logo logoAppleStore"
                                                    />
                                                </Link>
                                                <p className="desc font-family-regular require-os">
                                                    {t('support.download.requires_ios')}
                                                    {iosAppVersionInfo.minOSVersion} {t('support.download.above')}
                                                </p>
                                            </div>
                                            <div className="play-item google">
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href={APP_ANDROID}
                                                    ariaLabel={t('support.download.google_play')}
                                                    dataLayer={{ ...getAppDataLayer('Google Play'), __btn_id1: css.downloadContainer, __btn_id2: APP_ANDROID }}
                                                >
                                                    <EFPic
                                                        name={[`google-play.webp`, `google-play.png`]}
                                                        alt={t('support.download.google_play')}
                                                        className="logo logoAppleStore"
                                                    />
                                                </Link>
                                                <p className="desc font-family-regular require-os">
                                                    {t('support.download.requires_android')}
                                                    {androidAppVersionInfo.minOSVersion}
                                                    {t('support.download.above')}
                                                </p>
                                            </div>
                                            <div className="play-item qr-content">
                                                <EFAppQRCode width="93px" height="93px" />
                                                <p className="desc font-family-regular">{lang.site_support_download_scan}</p>
                                            </div>
                                        </div>
                                        <div className="download-apk">
                                            <Link
                                                className="GtmModuleData-btn-href"
                                                href={locale === 'cn' ? APK_CN : APK_OVERSEAS}
                                                ariaLabel={s('site_support_download_apk')}
                                                selfWin
                                                dataLayer={{
                                                    ...getAppDataLayer('Download the EcoFlow App apk file'),
                                                    __btn_id1: css.downloadContainer,
                                                    __btn_id2: locale === 'cn' ? APK_CN : APK_OVERSEAS,
                                                }}
                                            >
                                                <span className="imgs">
                                                    <EFDownloadAppPCSvg width="14px" height="14px" className="download-svg" />
                                                </span>
                                                {lang.site_support_download_apk}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            {HAS_PRO_APP_SITE && (
                                <SwiperSlide className="swiper-item">
                                    <EcoFlowProApp lang={lang} />
                                </SwiperSlide>
                            )}
                        </Swiper>
                    )}
                    {['cn', 'eu', 'uk', 'de', 'fr', 'es', 'it', 'us', 'ca', 'tw', 'jp', 'nl'].includes(locale) && isShowUPS && <SupportDownloadA />}
                    <div className={`download-content ${isMobile ? 'downloadContentH5' : ''}`} id="documentation">
                        <SupportTitle
                            title={i.doc}
                            content={
                                ['ca', 'us'].includes(locale)
                                    ? {
                                          link: '/support/warranty',
                                          text: s('site_support_download_warranty'),
                                      }
                                    : null
                            }
                        />
                        {isMobile ? (
                            <div className="downloadBox">
                                <div className="search-box">
                                    <div className="input-box">
                                        <input
                                            type="text"
                                            className="search"
                                            value={searchValue}
                                            onChange={handdleChangeSearch}
                                            placeholder={t('support.faq.site_support_faq_search')}
                                        />
                                        <EFPicPc
                                            className="search-icon"
                                            name={['search-icon.webp', 'search-icon.png']}
                                            alt={t('support.faq.site_support_faq_search')}
                                        />
                                    </div>
                                    <button className="search-btn" onClick={() => searchValue && getDownloadList({ title: searchValue })}>
                                        {t('support.faq.site_support_faq_search')}
                                    </button>
                                </div>
                                <div className="selectorBox">
                                    <div className="leftSelector">
                                        <Popover
                                            overlayClassName="download-dropdown-h5"
                                            placement="bottom"
                                            content={
                                                <div className="downloadPopoverBox">
                                                    <div className="btnBox">
                                                        <div className="okBtn" onClick={onOk}>
                                                            {t('common.confirm_text')}
                                                        </div>
                                                    </div>
                                                    <ul className="categoryLists">
                                                        <Collapse
                                                            expandIconPosition={'right'}
                                                            onChange={changeCatagory}
                                                            accordion
                                                            ghost
                                                            destroyInactivePanel
                                                            defaultActiveKey={[1]}
                                                            expandIcon={({ isActive }) => (
                                                                <div className="minusPlusIconBox">
                                                                    <Image
                                                                        src={
                                                                            isActive
                                                                                ? '/icons/mobileH5/minus_black_h5.svg'
                                                                                : '/icons/mobileH5/plus_black_h5.svg'
                                                                        }
                                                                        layout="fill"
                                                                        className="fullImgs"
                                                                        alt={isActive ? t('support.download.minus') : t('support.download.plus')}
                                                                    />
                                                                </div>
                                                            )}
                                                        >
                                                            {categoryTree?.map((category: any) => (
                                                                <Collapse.Panel
                                                                    header={category.name}
                                                                    key={category.downloadCatagoryId}
                                                                    showArrow={category?.subs?.length > 0}
                                                                    // className={
                                                                    //     defaultActiveId[0] === category.downloadCatagoryId && !category?.subs ? 'active-l1' : ''
                                                                    // }
                                                                >
                                                                    {category?.subs?.length > 0 && (
                                                                        <div className="subLists">
                                                                            <Collapse onChange={changeCatagory} accordion ghost defaultActiveKey={[1]}>
                                                                                {category?.subs?.map((sub: any) => (
                                                                                    <Collapse.Panel
                                                                                        header={sub.name}
                                                                                        key={`${category.downloadCatagoryId}++${sub.downloadCatagoryId}`}
                                                                                        showArrow={sub?.subs?.length > 0}
                                                                                        className={
                                                                                            defaultActiveId.indexOf(sub.downloadCatagoryId) !== -1
                                                                                                ? sub?.subs?.length > 0
                                                                                                    ? 'active-l2'
                                                                                                    : 'active-l2 no-children'
                                                                                                : ''
                                                                                        }
                                                                                    >
                                                                                        {sub?.subs?.length > 0 && (
                                                                                            <Collapse
                                                                                                className="sub2Lists"
                                                                                                onChange={changeCatagory}
                                                                                                accordion
                                                                                                ghost
                                                                                                defaultActiveKey={[1]}
                                                                                            >
                                                                                                {sub?.subs?.map((sub2: any) => (
                                                                                                    <Collapse.Panel
                                                                                                        header={sub2.name}
                                                                                                        className={
                                                                                                            defaultActiveId.indexOf(sub2.downloadCatagoryId) !==
                                                                                                            -1
                                                                                                                ? 'active-l3'
                                                                                                                : ''
                                                                                                        }
                                                                                                        key={`${category.downloadCatagoryId}++${sub.downloadCatagoryId}++${sub2.downloadCatagoryId}`}
                                                                                                        showArrow={false}
                                                                                                    />
                                                                                                ))}
                                                                                            </Collapse>
                                                                                        )}
                                                                                    </Collapse.Panel>
                                                                                ))}
                                                                            </Collapse>
                                                                        </div>
                                                                    )}
                                                                </Collapse.Panel>
                                                            ))}
                                                        </Collapse>
                                                    </ul>
                                                </div>
                                            }
                                            trigger="click"
                                            visible={popShow}
                                            onVisibleChange={handleVisibleChange}
                                        >
                                            <div className="leftSelectText font-family-semibold">
                                                {mainSelectorValue}
                                                <div className={`iconBox ${popShow ? 'show' : ''}`}>
                                                    <EFArrowDown
                                                        style={{
                                                            fontSize: '.12rem',
                                                            marginTop: '0.03rem',
                                                            marginLeft: '0.03rem',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </Popover>
                                    </div>
                                    {/* <div
                                        className="rightSelector"
                                        style={{
                                            display: level3Catagories?.length > 0 ? 'inline-block' : 'none',
                                        }}
                                    >
                                        <Select
                                            className="download_selector_h5"
                                            value={subSelectorValue}
                                            suffixIcon={() => (
                                                <div className={`iconBox ${selectOpen ? 'selectOpen' : ''}`}>
                                                    <EFArrowDown
                                                        style={{
                                                            fontSize: '.12rem',
                                                            marginTop: '0.03rem',
                                                            color: '#000',
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            onChange={tabChange}
                                            onDropdownVisibleChange={changeVisibleDropdown}
                                        >
                                            {level3Catagories.length > 0 &&
                                                level3Catagories?.map((catagory: any, k: number) => (
                                                    <Select.Option value={catagory.value} key={catagory.downloadCatagoryId}>
                                                        {catagory.name}
                                                    </Select.Option>
                                                ))}
                                        </Select>
                                    </div> */}
                                </div>
                                <EfTab activeType={type} className="download-tab" items={typeTabList} onChange={handleChangeType} />
                                {type === 'manual' && (
                                    <EfTab
                                        className="download-tab"
                                        activeType={subType}
                                        items={subTypeTabList}
                                        onChange={(val: any) => setSubType(val?.type || undefined)}
                                    />
                                )}
                                <CustomSpin
                                    loading={loading}
                                    customStyle={{
                                        position: 'relative',
                                        left: '0.2rem',
                                        top: '0.2rem',
                                    }}
                                />
                                <ul className="downloadListBox" style={{ opacity: loading ? 0 : 1 }}>
                                    {Array.isArray(fileList) &&
                                        fileList?.map((file: any, k: number) => (
                                            <li className="fileList" key={k}>
                                                <div className="fileContent">
                                                    <p className="fillTitle font-family-medium">{file.title}</p>
                                                    <p className="fileDate font-family-medium">{file.updateTime}</p>
                                                </div>
                                                <Link
                                                    className="GtmModuleData-btn-href"
                                                    href={file.fileUrl}
                                                    ariaLabel={file.classify === 'MANUAL' ? s('Download PDF') : s('Play video')}
                                                    dataLayer={{ ...getFileDataLayer(file, k), __btn_id1: css.downloadContainer, __btn_id2: file.fileUrl }}
                                                >
                                                    <div className="donwnLoadBtn font-family-semibold">
                                                        {file.classify !== 'ONLINE' && (
                                                            <div className="downLoadIcon">
                                                                <Image
                                                                    src={
                                                                        file.classify === 'MANUAL'
                                                                            ? '/img/download/download-icon.svg'
                                                                            : '/img/download/play.svg'
                                                                    }
                                                                    layout="fill"
                                                                    alt={
                                                                        file.classify === 'MANUAL'
                                                                            ? t('support.download.download_icon')
                                                                            : t('support.download.play_icon')
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                        {file.classify === 'ONLINE' && (
                                                            <svg
                                                                width="16"
                                                                height="16"
                                                                className="downLoadIcon"
                                                                viewBox="0 0 16 16"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <g stroke="currentColor" strokeWidth=".2" fill="currentColor" fillRule="nonzero">
                                                                    <path d="M15.031 8.001a.616.616 0 0 0-.019-.163.795.795 0 0 0-.03-.158l-.012-.03a.488.488 0 0 0-.024-.064C13.65 4.75 10.858 2.844 8 2.844c-2.857 0-5.649 1.904-6.94 4.725a.47.47 0 0 0-.033.086.813.813 0 0 0-.01.023c-.025.075-.026.127-.023.114a1.916 1.916 0 0 0-.023.163.406.406 0 0 0 0 .093s.01.095.016.114a.785.785 0 0 0 .016.102.47.47 0 0 0 .029.09.544.544 0 0 0 .022.059C2.352 11.25 5.144 13.155 8 13.155c2.858 0 5.65-1.905 6.932-4.712a.494.494 0 0 0 .042-.101.46.46 0 0 0 .035-.148c.008-.045.022-.113.022-.194zm-.947.035-.002.007-.006.02C12.922 10.55 10.486 12.22 8 12.22c-2.48 0-4.912-1.664-6.077-4.16l-.008-.025c0-.008-.002-.015-.003-.02l-.002-.018V7.99a.331.331 0 0 0 .006-.032.948.948 0 0 0 .005-.019C3.076 5.451 5.514 3.781 8 3.781c2.487 0 4.925 1.671 6.075 4.156l.004.012.004.013a.512.512 0 0 0 .007.046l-.006.028z"></path>
                                                                    <path d="M8 5.656A2.346 2.346 0 0 0 5.656 8 2.346 2.346 0 0 0 8 10.344 2.346 2.346 0 0 0 10.344 8 2.346 2.346 0 0 0 8 5.656zm0 3.75c-.775 0-1.406-.63-1.406-1.406 0-.775.63-1.406 1.406-1.406.775 0 1.406.63 1.406 1.406 0 .775-.63 1.406-1.406 1.406z"></path>
                                                                </g>
                                                            </svg>
                                                        )}
                                                        {file.classify === 'MANUAL' ? 'PDF' : file.classify === 'ONLINE' ? t('product.view') : 'Video'}
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                                {Array.isArray(fileList) && fileList?.length > 0 && (
                                    <div className="page-content">
                                        <Pagination
                                            className="page"
                                            current={pageInfo.page}
                                            pageSize={pageInfo.size}
                                            total={pageInfo.total}
                                            hideOnSinglePage={true}
                                            showSizeChanger={false}
                                            onChange={handlePageChange}
                                        />
                                    </div>
                                )}
                                {/* 无数据情况 */}
                                {(!Array.isArray(fileList) || fileList?.length === 0) && !isFirstIn && <Empty isMobile />}
                            </div>
                        ) : (
                            <div className="download-list">
                                {/*左侧菜单栏*/}
                                <SupportLeftMenu
                                    categoryTree={categoryTree}
                                    defaultOpenIds={defaultOpenInfo.openIdsForPC}
                                    defaultSelectId={defaultOpenInfo.selectIdForPC}
                                    fieldNames={{
                                        title: 'name',
                                        value: 'downloadCatagoryId',
                                        children: 'subs',
                                        type: 'downloadCatagoryType',
                                    }}
                                    onSearch={(title: string) => getDownloadList({ title })}
                                    onSelect={(ids: string, type: string) => {
                                        if (type === 'PRODUCT_CATAGORY') {
                                            return getDownloadList({ productCatagoryIds: ids });
                                        }
                                        if (type === 'SPU') {
                                            return getDownloadList({ spuIds: ids });
                                        }
                                        if (type === 'SKU') {
                                            return getDownloadList({ skuIds: ids });
                                        }
                                        if (type === 'SN') {
                                            return getDownloadList({ snInSkuIds: ids });
                                        }
                                    }}
                                />
                                {/*右侧content*/}
                                <ul className="fileList">
                                    <EfTab className="download-tab" items={typeTabList} activeType={type} onChange={handleChangeType} />
                                    {type === 'manual' && (
                                        <EfTab
                                            className="download-tab"
                                            activeType={subType}
                                            items={subTypeTabList}
                                            onChange={(val: any) => setSubType(val?.type || undefined)}
                                        />
                                    )}
                                    <CustomSpin loading={loading} customStyle={{ position: 'relative', top: '30px' }} />
                                    {Array.isArray(fileList) &&
                                        fileList?.length > 0 &&
                                        fileList?.map((file: any, index: number) => (
                                            <li className="fileItem" key={file.downloadInfoId} style={{ opacity: !loading ? 1 : 0 }}>
                                                <div className="file-icon">{file.classify === 'MANUAL' ? iconMap.pdf.fileIcon : iconMap.video.fileIcon}</div>
                                                <div className="content">
                                                    <p className="desc font-family-medium">{file.title}</p>
                                                    <p className="time font-family-medium">{file.updateTime}</p>
                                                    <Link
                                                        className="GtmModuleData-btn-href"
                                                        href={file.fileUrl}
                                                        ariaLabel={file.classify === 'MANUAL' ? s('Download PDF') : s('Play video')}
                                                        dataLayer={{
                                                            ...getFileDataLayer(file, index),
                                                            __btn_id1: css.downloadContainer,
                                                            __btn_id2: file.fileUrl,
                                                        }}
                                                    >
                                                        <span className="download-btn font-family-semibold">
                                                            {file.classify === 'MANUAL' ? (
                                                                <span className="pdfDownload"></span>
                                                            ) : file.classify === 'ONLINE' ? (
                                                                <svg
                                                                    width="16"
                                                                    height="16"
                                                                    style={{ marginRight: '2px' }}
                                                                    viewBox="0 0 16 16"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <g stroke="currentColor" strokeWidth=".2" fill="currentColor" fillRule="nonzero">
                                                                        <path d="M15.031 8.001a.616.616 0 0 0-.019-.163.795.795 0 0 0-.03-.158l-.012-.03a.488.488 0 0 0-.024-.064C13.65 4.75 10.858 2.844 8 2.844c-2.857 0-5.649 1.904-6.94 4.725a.47.47 0 0 0-.033.086.813.813 0 0 0-.01.023c-.025.075-.026.127-.023.114a1.916 1.916 0 0 0-.023.163.406.406 0 0 0 0 .093s.01.095.016.114a.785.785 0 0 0 .016.102.47.47 0 0 0 .029.09.544.544 0 0 0 .022.059C2.352 11.25 5.144 13.155 8 13.155c2.858 0 5.65-1.905 6.932-4.712a.494.494 0 0 0 .042-.101.46.46 0 0 0 .035-.148c.008-.045.022-.113.022-.194zm-.947.035-.002.007-.006.02C12.922 10.55 10.486 12.22 8 12.22c-2.48 0-4.912-1.664-6.077-4.16l-.008-.025c0-.008-.002-.015-.003-.02l-.002-.018V7.99a.331.331 0 0 0 .006-.032.948.948 0 0 0 .005-.019C3.076 5.451 5.514 3.781 8 3.781c2.487 0 4.925 1.671 6.075 4.156l.004.012.004.013a.512.512 0 0 0 .007.046l-.006.028z"></path>
                                                                        <path d="M8 5.656A2.346 2.346 0 0 0 5.656 8 2.346 2.346 0 0 0 8 10.344 2.346 2.346 0 0 0 10.344 8 2.346 2.346 0 0 0 8 5.656zm0 3.75c-.775 0-1.406-.63-1.406-1.406 0-.775.63-1.406 1.406-1.406.775 0 1.406.63 1.406 1.406 0 .775-.63 1.406-1.406 1.406z"></path>
                                                                    </g>
                                                                </svg>
                                                            ) : (
                                                                <span className="videoDownload"></span>
                                                            )}
                                                            {file?.classify === 'MANUAL' ? 'PDF' : file?.classify === 'ONLINE' ? t('product.view') : 'Video'}
                                                        </span>
                                                    </Link>
                                                </div>
                                            </li>
                                        ))}
                                    {Array.isArray(fileList) && fileList?.length > 0 && (
                                        <div className="page-content">
                                            <Pagination
                                                className="page GtmModuleData-btn-text"
                                                current={pageInfo.page}
                                                pageSize={pageInfo.size}
                                                total={pageInfo.total}
                                                hideOnSinglePage={true}
                                                showSizeChanger={false}
                                                onChange={handlePageChange}
                                            />
                                        </div>
                                    )}
                                    {/* 无数据情况  */}
                                    {(!Array.isArray(fileList) || fileList.length === 0) && !isFirstIn && <Empty />}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>

                {hideContactUs !== '1' && <SupportContactUs isShow={true} />}
            </div>
            <GoToIpForThePage />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale, params }: GetServerSidePropsContext) {
    if (!isReadyLang(locale || '') && locale !== 'en') {
        return redirectTo404();
    }
    API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
    let categoryTree = [];
    let iosAppVersionInfo = {};
    let usSeoMap: any[] = [];
    let isShowUPS = false;
    const resArr = await Promise.all([getDownloadCatagoryTree(locale), getIosAppVersion(locale)]);
    const usSeoRes = await efFetch(`${API_HOST}/seoPage?locale=${locale}`).catch(() => ({}));
    usSeoMap = usSeoRes?.data || [];

    categoryTree = resArr[0]?.data || [];

    const curTime = new Date().getTime();
    const upsModalTime = new Date('2024/09/10 15:00:00 GMT+8').getTime();

    if (curTime > upsModalTime) {
        isShowUPS = true;
    }

    if (Array.isArray(resArr[1]?.results)) {
        iosAppVersionInfo = {
            iosAppVersion: resArr[1].results[0]?.version,
            minOSVersion: resArr[1].results[0]?.minimumOsVersion,
        };
    }

    return {
        props: {
            categoryTree: categoryTree,
            iosAppVersionInfo,
            androidAppVersionInfo: {
                appVersion: resArr[2]?.version || '2.6.2',
                minOSVersion: resArr[2]?.androidVersion || '5.0',
            },
            product: params?.product,
            usSeoMap,
            isShowUPS,
        },
    };
}
